import { TagKindSchema, TagSchema } from "@redotech/redo-model/tag";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";

export const editTag = {
  name: "editTag" as const,
  input: z.object({
    oldName: z.string(),
    kind: TagKindSchema,
    newTag: TagSchema,
  }),
  output: zNull(),
};
